import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FbSwitchButtonConfiguration } from '../components/fb-switch-button/fb-switch-button.configuration';
import { UserService } from "../_core/lib/user.service";
import { FbTabPanelButtonConfiguration } from '../components/fb-tabpanel-button/fb-tabpanel-button.configuration';
import { MessageService } from 'primeng/api';
import { CtAuthenticationService } from '@ctsolution/ct-authentication';
import { Router } from '@angular/router';
import { TermsModalService } from '../components/terms-dialog/TermsModalService.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    providers: [MessageService]
})
export class AppMenuComponent implements OnInit {
    termsModalVisible = false;

    model: any[] = [];
    showLabel = false;
    switchButtonConfiguration: FbSwitchButtonConfiguration = FbSwitchButtonConfiguration
        .create(`Acquirente`, () => {
            this.userService.roleChecker.toggle();
            this.switchButtonConfiguration
                .setLabel(this.userService.roleChecker.is.seller() ? `Venditore` : `Acquirente`);
        });

    tabPanelButtonConfiguration: FbTabPanelButtonConfiguration = FbTabPanelButtonConfiguration.create(
    ["Acquirente", "Venditore"],
    () => {
        this.userService.roleChecker.toggle();
        this.show();
    },
    this.userService.roleChecker.is.customer() ? 0 : 1
);

    constructor(
        private userService: UserService,
        private messageService: MessageService,
        public _auth: CtAuthenticationService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private termsModalService: TermsModalService
    ) { }

    ngOnInit() {
        this.updateMenuBasedOnLoginStatus();
    }

    async show() {
    this.showLabel = this.userService.roleChecker.is.customer();

    this.model[0].items?.filter(x => x.type === RoleMenuEnum.CUSTOMER).forEach(x => {
        x.visible = this.showLabel;
    });

    this.cdr.detectChanges();

    if (this.userService.roleChecker.is.seller() && await this.userService.checkPermission() === false) {
        window.location.reload();
        return;
    }

    const label = this.userService.roleChecker.is.seller() ?
        `Stai utilizzando Foodbids nel ruolo di Venditore` :
        `Stai utilizzando Foodbids nel ruolo di Acquirente`;

    // Prima naviga via dalla dashboard, poi torna
    await this.router.navigateByUrl('/', { skipLocationChange: true });
    await this.router.navigate(['/dashboard']);

    // Mostra il messaggio dopo la navigazione
    this.messageService.add({ severity: 'success', summary: "Cambio effettuato", detail: label, key: 'br', life: 3000 });
}
    logout() {
        this.userService.deleteUser();
        this._auth.signOut();
    }

openTermsModal(event: Event): void {
  event.preventDefault();
  this.termsModalService.open();
}

    showItem(): boolean {
        return this.userService.roleChecker.is.seller();
    }

    updateMenuBasedOnLoginStatus() {
        this.model = [
            {
                label: '',
                items: this._auth.userValue
                    ? [
                        { label: 'Home', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Aste', icon: 'pi pi-fw pi-list', routerLink: ['/auction'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Notifiche', icon: 'pi pi-fw pi-bell', visible: true, type: RoleMenuEnum.ALL },
                        { label: 'I miei acquisti', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/my-purchases'], visible: this.showLabel, type: RoleMenuEnum.CUSTOMER },
                        { label: 'Area personale', icon: 'pi pi-fw pi-user', routerLink: ['/profile'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Faq', icon: 'pi pi-fw pi-question-circle', routerLink: ['/faq'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Logout', icon: 'pi pi-fw pi-sign-out', command: () => this.logout(), visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Termini e codizioni', icon: 'pi pi-fw pi-file-o', command: () => this.openTermsModal(event), visible: true, type: RoleMenuEnum.ALL },
                    ]
                    : [
                        { label: 'Accedi', icon: 'pi pi-fw pi-sign-in', routerLink: ['/login'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Home', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Faq', icon: 'pi pi-fw pi-question-circle', routerLink: ['/faq'], visible: true, type: RoleMenuEnum.ALL },
                        { label: 'Termini e codizioni', icon: 'pi pi-fw pi-file-o', command: () => this.openTermsModal(event), visible: true, type: RoleMenuEnum.ALL },
                    ]
            }
        ];
    }
}

export enum RoleMenuEnum {
    ALL = 1,
    CUSTOMER = 2,
    SELLER = 3
}
